export const ENV_CONFIG = {
    XSOLLA: {
        API_KEY: process.env.REACT_APP_XSOLLA_API_KEY,
        MERCHANT_ID: process.env.REACT_APP_XSOLLA_MERCHANT_ID,
        PROJECT_ID: process.env.REACT_APP_XSOLLA_KOMPETE_PROJECT_ID,
        STORE_BASE_URL: process.env.REACT_APP_XSOLLA_STORE_TARGET_SERVER,
    },
};